module.exports = __webpack_public_path__ + "img/Karpicko_tlo_sm.8d9ccc78.png";